window.DS24 = window.DS24 || {};

DS24.cart = (() => {

    async function handleAdd(btn) {

        const originalHtml = btn.innerHTML;

        btn.disabled = true;
        btn.classList.add('processing');

        btn.innerHTML = `
            <span class="spinner"></span>
            Wird hinzugefügt...
        `;
        await new Promise(resolve => setTimeout(resolve, 1000));

        try {

            window.ds24_affiliate =
                DS24.helpers.getPersisted(
                    "ds24_affiliate"
                );

            window.ds24_campaignkey =
                DS24.helpers.getPersisted(
                    "ds24_campaignkey"
                );

            window.ds24_trackingkey =
                DS24.helpers.getPersisted(
                    "ds24_trackingkey"
                );

            let digistoreId =
                DS24.helpers.getDigistoreId(btn);

            if (!digistoreId) {
                const productId =
                    DS24.helpers.getShopifyProductId();

                if (!productId) {

                    throw new Error(
                        "Produkt-ID fehlt"
                    );
                }

                digistoreId =
                    await DS24.helpers.resolveDigistoreId(
                        productId
                    );
            }

            if (!digistoreId) {

                throw new Error(
                    "Produkt nicht verfügbar"
                );
            }

            const qty =
                DS24.helpers.getQuantity();

            ds24cart_add(
                digistoreId,
                qty
            );

            btn.classList.remove('processing');
            btn.classList.add('success');

            btn.innerHTML = `
                <span class="checkmark">✓</span>
                Hinzugefügt
            `;

            setTimeout(() => {

                btn.disabled = false;
                btn.classList.remove('success');
                btn.innerHTML = originalHtml;

            }, 1000);

        } catch (error) {

            btn.disabled = false;
            btn.classList.remove('loading');
            btn.innerHTML = originalHtml;

            alert(
                error.message ||
                'Ein Fehler ist aufgetreten'
            );
        }
    }

    function bindAddToCart() {

        document.addEventListener(
            "click",
            async function (e) {

                const btn = e.target.closest(
                    'button[name="add"], .product-form__submit'
                );

                if (!btn) {
                    return;
                }

                if (btn.closest('#ContactForm')) {
                    return;
                }

                if (btn.closest('#ContactFooter')) {
                    return;
                }

                e.preventDefault();

                handleAdd(btn);
            }
        );
    }

    function bindCartIcon() {

        document.addEventListener(
            "click",
            function (e) {

                const cart = e.target.closest(
                    'a[href="/cart"], .ds-cart-icon'
                );

                if (!cart) {
                    return;
                }

                e.preventDefault();

                ds24cart_show(cart);
            }
        );
    }

    function injectContinueButton() {

        const footer = document.querySelector(
            ".app_cart_tooltip_container.open .app_cart_buttons"
        );
        
        if (!footer) {
            return;
        }

        if (
            footer.querySelector(
                "#ds-continue-shopping"
            )
        ) {
            return;
        }

        const btn = document.createElement("button");

        btn.id = "ds-continue-shopping";

        btn.className =
            "ds24-continue-shopping-btn";

        btn.innerHTML =
            "Weiter einkaufen";

        btn.onclick = function () {

            const closeBtn = document.querySelector(
                ".app_dialog_button_close"
            );

            if (closeBtn) {

                closeBtn.click();

            } else {

                window.location.href =
                    DS24_CONFIG.continueUrl;
            }
        };

        footer.appendChild(btn);
    }

    function observeCart() {

        const observer = new MutationObserver(() => {

            injectContinueButton();

        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /*
    |--------------------------------------------------------------------------
    | GLOBAL CALLBACK
    |--------------------------------------------------------------------------
    */

    window.onDigistoreCartChange = function(cart) {

        window.ds24cart = cart;

        DS24.quickAddBulk.syncCart(cart);

        DS24.quickAddBulk.hideAllProgressBars();

        const totalQty = cart.items.reduce(
            (total, item) =>
                total +
                Number(item.quantity || 0),
            0
        );

        DS24.helpers.updateBubble(
            totalQty
        );
        DS24.helpers.animateCartIcon();

        DS24.gift.handle(cart);

        setTimeout(() => {
            DS24.shipping.handle(cart);
        }, 500);
    };

    function init() {

        bindAddToCart();

        bindCartIcon();

        injectContinueButton();

        observeCart();
    }

    document.addEventListener(
        "DOMContentLoaded",
        init
    );

})();